(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('LaunchObjectTestController', LaunchObjectTestController);

    LaunchObjectTestController.$inject = ['$scope', '$state', 'ObjectTestResult', 'ParseLinks', 'AlertService', 'id', 'TabObjects', '$timeout', 'TestSettingTag', '$uibModal', '$filter'];

    function LaunchObjectTestController($scope, $state, ObjectTestResult, ParseLinks, AlertService, id, TabObjects, $timeout, TestSettingTag) {
        var vm = this;
        vm.tabObjects = [];
        vm.objectTestResults = [];
        vm.charToSearch = "";
        vm.page = 0;
        vm.running = false;
        vm.filterTag = [];
        vm.currentStateTag = "launch-object-test-tag";

        var tag = localStorage.getItem(vm.currentStateTag);

        if (id !== null && id !== undefined && vm.filterTag.length === 0) {
            var tag = localStorage.getItem(vm.currentStateTag);
            if (tag != null && tag != "null") {
                vm.filterTag = JSON.parse(tag);
            }
        }

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
            vm.testsTag.forEach((tag)=>{
                tag.label = tag.testTag;
            })
        })

        vm.obj = id !== null && id !== undefined ? { id } : {};
        vm.objectTestResults = [];
        loadTest();

       /* if (id !== null && id !== undefined) {
            vm.obj = {};
            vm.obj.id = id;
            vm.objectTestResults = [];
            loadTest();
        }
    */
        vm.reloadTest = function () {
            vm.objectTestResults = [];
            loadTest();
        }

        function loadTest() {
            vm.hasNotResults = false;
            TabObjects.get({id: vm.obj.id}).$promise.then(function (data) {
                vm.obj = data;
                vm.areChk = false;
                var tagList = vm.filterTag.length > 0 ? vm.filterTag : vm.testsTag;
                var tagIds = tagList.map(function(tag) {
                    return tag.id;
                });

                localStorage.setItem(vm.currentStateTag, JSON.stringify(vm.filterTag));

                var promises = tagIds.map(function(tagId) {
                    return ObjectTestResult.byTags({
                        object: vm.obj.id,
                        testTagId: tagId,
                        isManual: false}).$promise;

                });
                Promise.all(promises).then(function (results) {
                    var tests = results.flat();
                    vm.objectTestResults = tests;
                    vm.objectTestResults.forEach(function (test) {
                        test.check = false;
                    });
                    vm.hasNotResults = tests.length === 0;
                });
            });
        }

        vm.applyTagsFilter = function ()  {
            loadTest()
        }

        vm.currentState = "launch-object-test";

        vm.loadAll = function () {
            TabObjects.query({
                page: vm.page,
                size: 20,
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjects.push(data[i]);
                }
                //vm.objNotSelected = vm.obj === undefined || vm.obj === null || vm.obj.id === null || vm.obj.id === undefined;
                vm.objNotSelected = !vm.obj || vm.obj.id === null || vm.obj.id === undefined;
            }
0
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.tagListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "Select tags",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };


        vm.reset = function () {
            vm.page = 0;
            vm.tabActions = [];
            vm.loadAll();
        };

        vm.loadPage = function (page) {
            if (page < vm.links['last'] || page === vm.links['next']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        vm.selectObject = function (obj) {
            vm.hasNotResults = false;
            $state.transitionTo($state.$current, {
                id: vm.obj.id
            }, {notify: true, location: "replace"});
        };

        vm.checkAll = function (b) {
            vm.objectTestResults.forEach(function (test) {
                test.check = vm.areChk;
            });
        }

        vm.areAllChecked = function () {
            var allChecked = true;
            var notChecked = true;
            vm.objectTestResults.forEach(function (test) {
                allChecked = test.check && allChecked;
                notChecked = !test.check && notChecked;
            });
            if(allChecked) vm.areChk = allChecked;
            else if(notChecked) vm.areChk = !notChecked;
        }

        vm.clickedAtLeastOneTest = function () {
            var isChecked = false;
            vm.objectTestResults.forEach(function (test) {
                isChecked = isChecked || test.check
            });
            return isChecked;
        }

        vm.checkedTestList = function () {
            var checkedTestList = [];
            vm.objectTestResults.forEach(function (test) {
                if(test.check) checkedTestList.push(test);
            });
            $state.transitionTo('launch-object-test.view', {
                id: vm.obj.id,
                testResults: checkedTestList
            }, {location: "replace"});
        }

        vm.runAll = function () {
            vm.running = true;
            for (var i = 0; i < vm.objectTestResults.length; i++) {
                if(vm.objectTestResults[i].check && !vm.objectTestResults[i].objectTestSetting.manual){
                    vm.runTest(vm.objectTestResults[i], i);
                }
            }
        };

        vm.runTest = function (test, i) {
            $timeout(function () {
                ObjectTestResult.execute(test).$promise.then(
                    function (result) {
                        vm.objectTestResults[i] = result;
                        vm.areChk = false;
                        vm.running = false;
                    },
                    function () {
                        AlertService.error("Test Error");
                    });
            }, 1000);
        };
    }
})();
